
var referringURL = document.referrer;

function checkShowCartDrawer() {
  let showCart = sessionStorage.getItem('showCart');
  if(cartCount > 0 && showCart != 1){
    return true;
  }else{
    return false;
  }
}

// function showCartDrawer(params) {
//   document.dispatchEvent(new CustomEvent("check-cart-empty", {
//     detail: {showCart : checkShowCartDrawer()}
//   }));
//   sessionStorage.setItem("showCart", 1);

//   var cartDrawer = document.getElementById('cart-drawer');
// 　　cartDrawer.style.zIndex = '99999999';
// }

// document.addEventListener('DOMContentLoaded', function() {
// if (referringURL) {
// 　　if (referringURL.includes('bonaventura') || referringURL.includes('shopifypreview')) {

// 　　} else {
//         setTimeout(function() {
//             showCartDrawer();
//         }, 3000);
// 　　}
// } else {
//         setTimeout(function() {
//             showCartDrawer();
//         }, 3000);
// }
// });
